import fetch from "../axiosConfig";

import Base64 from 'js-base64';
import axios from "axios";
import router from "../../router";
let $base = Base64.Base64;
//腾讯地址反查
export function clinicMap (data) {
  const headers = { "cbcloud-ssotoken": storage.get("cbcloud-ssotoken") };
  return fetch({
    url: "clinic/map",
    method: "get",
    params: data,
    headers: headers
  });
}
//腾讯地址关键词搜索
export function clinicsuggestion (data) {
  const headers = { "cbcloud-ssotoken": storage.get("cbcloud-ssotoken") };
  return fetch({
    url: "/clinic/suggestion",
    method: "get",
    params: data,
    headers: headers
  });
}
//模板格式导出
export function clinicdownload (data) {
  const headers = { "cbcloud-ssotoken": storage.get("cbcloud-ssotoken") };
  return fetch({
    url: "/clinic/download",
    method: "get",
    responseType: 'blob',
    params: data,
    headers: headers
  });
}
//导出excel
export function downloadFile (data, filename) {
  if (!data) {
    return;
  }
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.style.display = 'none';
  link.href = url;
  link.setAttribute('download', filename + '.xlsx');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link)
}
//导出zip
export function downloadZipFile (data, fileName) {
  if (!data) {
    return;
  }
  // 这里的res.data为后端返回的流数据
  let blob = new Blob([data], { type: 'application/zip' })

  let aLink = document.createElement('a')
  aLink.style.display = 'none'
  aLink.download = fileName // 下载文件的名字
  aLink.href = URL.createObjectURL(blob)
  aLink.click()
  URL.revokeObjectURL(aLink) // 释放内存
}

//登录
export function login (data) {
  return fetch({
    url: "/login/token",
    method: "post",
    data
  });
}

//退出登录
export function LogoutApi () {
  return fetch({
    url: "/login/logout",
    method: "get",
  });
}

//切换账户登录
export function changeAccount (params) {
  return fetch({
    url: "/login/switchOrgLogin",
    method: "get",
    params
  });
}
// 获取用户所属机构列表
export function getOrgSelect (params) {
  return fetch({
    url: "/login/getOrgSelect ",
    method: "get",
    params
  });
}
//门省市区字典-获取全部列表树
export function getAddresTrees (data) {
  return fetch({
    url: "/cityData/getAllTrees",
    method: "get",
    params: data,
  });
}


//获取省市区
export function cityDatagetFullLayTree (data) {
  return fetch({
    url: "/cityData/getFullLayTree",
    method: "get",
    params: data,
  });
}
//诊所目录-春播省区
export function clinicProvince (data) {
  return fetch({
    url: "/organization/getCbAllProvinces",
    method: "get",
    params: data,
  });
}
//诊所目录-春播市区
export function clinicCity (data) {
  return fetch({
    url: "/clinic/city",
    method: "get",
    params: data,
  });
}

//上传
export function upload (data) {
  let headers = { "Content-Type": "multipart/form-data" };
  return fetch({
    url: "/oss/upload",
    method: "post",
    headers: headers,
    data: data,
  });
}

// 查询字典表
export function findDic (data) {
  return fetch({
    url: "/dicCode/getDicCodeByType",
    method: "post",
    data: data
  })
}

//查询OA待办任务数量
export function getOAWaitCount () {
  return fetch({
    url: "/oa/getOAWaitCount",
    method: "post",
    headers:{ "load": "pass" }

  })
}
/**机构查询-左侧树 */
export function getCompanyOrgTrees (params) {
  return fetch({
    url: "/sysOrgCompany/getCompanyOrgTrees",
    method: "get",
    params
  });
}







// WEBPACK FOOTER //
// ./src/api/utils/index.js